import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Accueil", href: "/" },
  { label: "Covering cuisine", href: "/covering-cuisine" },
  { label: "Réalisations", href: "/realisations" },
  { label: "Zones d'intervention", href: "/zones-intervention" },
  { label: "Contact", href: "/contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0284FC]/90 border-b border-white/10 shadow-lg shadow-black/5"
          : "bg-[#0284FC]/95 border-b border-white/10"
      }`}
    >
      <div className="max-w-[1450px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-24 sm:h-28 lg:h-[156px]">
          <a href="/" data-testid="nav-logo" className="shrink-0 flex items-center" aria-label="Vinylux - Accueil">
            <img src="/logo.png" alt="Vinylux - rénovation de cuisine par covering" className="h-[92px] sm:h-[104px] lg:h-[146px] xl:h-[154px] w-auto object-contain scale-105" />
          </a>

          <div className="hidden lg:flex items-center gap-6 xl:gap-8 ml-10 xl:ml-14 mr-7">
            {NAV_LINKS.map((link) => (
              <a key={link.href} href={link.href} className="text-sm xl:text-[15px] font-semibold text-white/90 hover:text-white transition-colors whitespace-nowrap">
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-4 shrink-0">
            <a href="tel:+33695134999" data-testid="nav-phone" className="flex items-center gap-2 text-[15px] font-semibold text-white hover:text-white/80 transition-colors whitespace-nowrap">
              <Phone className="w-4 h-4" />06 95 13 49 99
            </a>
            <a href="/contact" data-testid="nav-cta" className="bg-white hover:bg-white/90 text-[#0284FC] text-[15px] font-bold px-5 py-3 rounded-full transition-all hover:scale-[1.03] whitespace-nowrap">
              Devis gratuit
            </a>
          </div>

          <button data-testid="mobile-menu-toggle" className="lg:hidden p-2 text-white" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Ouvrir le menu" aria-expanded={mobileOpen}>
            {mobileOpen ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-[#0284FC]/95 backdrop-blur-xl border-t border-white/10 px-6 pb-6 pt-3">
          <div className="flex flex-col">
            {NAV_LINKS.map((link) => (
              <a key={link.href} href={link.href} className="block py-3 text-base font-semibold text-white/90 hover:text-white transition-colors">
                {link.label}
              </a>
            ))}
            <a href="tel:+33695134999" className="mt-3 block text-center border border-white/20 text-white font-semibold px-5 py-3 rounded-full">06 95 13 49 99</a>
            <a href="/contact" className="block mt-3 text-center bg-white text-[#0284FC] font-bold px-5 py-3 rounded-full">Devis gratuit</a>
          </div>
        </div>
      )}
    </nav>
  );
}
